import { SavedReportsCard } from "@/Features/SavedReports";
import { saveFprReport } from "../../../../api";

export const SavedReports = ({ reportInfo }) => (
  <SavedReportsCard reportInfo={reportInfo} saveReport={saveFprReport} />
);
